import { State } from 'src/redux/reducer';
import { isLoaded, isPending, shouldLoad } from 'src/redux/utils';

export const addModelsSelector = (state: State) => state.addModels.entities;
export const addModelsStatusSelector = (state: State) => state.addModels.status;
export const addModelsLoadedSelector = isLoaded(addModelsStatusSelector);
export const addModelsPendingSelector = isPending(addModelsStatusSelector);
export const shouldAddModelsSelector = shouldLoad(addModelsStatusSelector);
